// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"89d0def3","467":"3a183e43","787":"31576d61"}[chunkId] + ".chunk.js";
};